export const ENVIRONMENT_MASTER = 'Master'
export const ENVIRONMENT_STAGING = 'Staging'
export const ENVIRONMENT_DEVELOPMENT = 'Development'
export const ENVIRONMENT_LOCALHOST = 'localhost'
export const LOCAL_ENV_DEVELOPMENT = 'development'
